<template>
	<div style="height: 100%;">
		<!-- <MyBread v-bind:BreadcrumbList="BreadcrumbList"></MyBread> -->
		<div class="demo-split">
			<Split v-model="split1">
				<div slot="left" class="demo-split-pane">
					<Form :model="formInlineP" inline style="text-align: left;margin-top: 1%;">
						<FormItem v-if="priceModal=='查询'" prop="trackName" label="查询模板名称:" :label-width="100">
							<Select v-model="selectPriceId" placeholder="模板列表" style="width: 200px;" @on-change="showPriceModel">
								<Option :key="itemIndex" v-for="(item,itemIndex) in PriceList" :value="item.Id">
									{{item.Name}}
								</Option>
							</Select>
						</FormItem>
						<FormItem v-if="priceModal=='新增'" prop="Name" label="新增模板名称:" :label-width="100">
							<Input type="text" v-model="formInlineP.Name" placeholder="新增模板名称" />
						</FormItem>
						<FormItem v-if="priceModal=='新增'" style='float: right;'>
							<Button type="primary" @click="handleSubmitP('add')" v-if="hasWidgets('save')">保存</Button>
						</FormItem>
						<FormItem v-if="priceModal=='查询'" style='float: right;'>
							<Button type="primary" @click="handleSubmitP('changeModalAdd')">切换为新增价格模板</Button>
						</FormItem>
						<FormItem v-if="priceModal=='新增'" style='float: right;'>
							<Button type="primary" @click="handleSubmitP('changeModalSelect')">切换为查询模板价格</Button>
						</FormItem>
						<FormItem v-if="priceModal=='实时价格'" label="查看实时价格的枪编号:" :label-width="150">
							<Input type="text" v-model="currentConn" placeholder="新增模板名称" />
						</FormItem>
						<FormItem v-if="priceModal=='实时价格'" style='float: right;'>
							<Button type="error" @click="handleSubmitP('changeModalSelect')">关闭枪实时价格查看</Button>
						</FormItem>
					</Form>
					<div style="border: 1px solid #d4cfc7;padding: 2px;">
						<Form ref="formInlineP" :model="formInlineP" inline style="text-align: left;margin-top: 1%;">
							<Row style="margin-top: 10px;" v-show="false">
								<Col span=5>
								<FormItem prop="Id" label="Id" :label-width="65">
									<TimeSelect :disabled="ifAddPrice" v-model="formInlineP.Id"></TimeSelect>
									<!-- <TimePicker :disabled="ifAddPrice" v-model="formInlineP.Period1BeginTime" format="HH:mm" :steps="[1,30]"
									 placeholder="Select time"></TimePicker> -->
								</FormItem>
								</Col>
								<Col span=5>
								<FormItem prop="Name" label="Name:" :label-width="65">
									<TimeSelect :disabled="ifAddPrice" v-model="formInlineP.Name"></TimeSelect>
								</FormItem>
								</Col>
							</Row>

							<Row style="margin-top: 10px;">
								<FormItem>
									<Tag color="primary">时段1</Tag>
								</FormItem>
								<FormItem prop="Period1BeginTime" label="时间" :label-width="40">
									<TimeSelect :disabled="ifAddPrice" v-model="formInlineP.Period1BeginTime" style="width: 70px;" />-
									<TimeSelect :disabled="ifAddPrice" v-model="formInlineP.Period1EndTime" style="width: 70px;" />
								</FormItem>
								<FormItem prop="Period1Price" label="电费单价" :label-width="70">
									<Input :disabled="ifAddPrice" type="text" v-model="formInlineP.Period1Price" placeholder="电费单价"
										style="width: 55px;" />
								</FormItem>
								<FormItem prop="Period1ServicePrice" label="服务费" :label-width="70">
									<Input :disabled="ifAddPrice" type="text" v-model="formInlineP.Period1ServicePrice" placeholder="服务费"
										style="width: 55px;" />
								</FormItem>
							</Row>
							<Row style="margin-top: 10px;">
								<FormItem>
									<Tag color="primary">时段2</Tag>
								</FormItem>
								<FormItem prop="Period2BeginTime" label="时间" :label-width="40">
									<TimeSelect :disabled="ifAddPrice" v-model="formInlineP.Period2BeginTime" style="width: 70px;" />-
									<TimeSelect :disabled="ifAddPrice" v-model="formInlineP.Period2EndTime" style="width: 70px;" />
								</FormItem>
								<FormItem prop="Period2Price" label="电费单价" :label-width="70">
									<Input :disabled="ifAddPrice" type="text" v-model="formInlineP.Period2Price" placeholder="电费单价"
										style="width: 55px;" />
								</FormItem>
								<FormItem prop="Period2ServicePrice" label="服务费" :label-width="70">
									<Input :disabled="ifAddPrice" type="text" v-model="formInlineP.Period2ServicePrice" placeholder="服务费"
										style="width: 55px;" />
								</FormItem>
							</Row>
							<Row style="margin-top: 10px;">
								<FormItem>
									<Tag color="primary">时段3</Tag>
								</FormItem>
								<FormItem prop="Period3BeginTime" label="时间" :label-width="40">
									<TimeSelect :disabled="ifAddPrice" v-model="formInlineP.Period3BeginTime" style="width: 70px;" />-
									<TimeSelect :disabled="ifAddPrice" v-model="formInlineP.Period3EndTime" style="width: 70px;" />
								</FormItem>
								<FormItem prop="Period3Price" label="电费单价" :label-width="70">
									<Input :disabled="ifAddPrice" type="text" v-model="formInlineP.Period3Price" placeholder="电费单价"
										style="width: 55px;" />
								</FormItem>
								<FormItem prop="Period3ServicePrice" label="服务费" :label-width="70">
									<Input :disabled="ifAddPrice" type="text" v-model="formInlineP.Period3ServicePrice" placeholder="服务费"
										style="width: 55px;" />
								</FormItem>
							</Row>
							<Row style="margin-top: 10px;">
								<FormItem>
									<Tag color="primary">时段4</Tag>
								</FormItem>
								<FormItem prop="Period4BeginTime" label="时间" :label-width="40">
									<TimeSelect :disabled="ifAddPrice" v-model="formInlineP.Period4BeginTime" style="width: 70px;" />-
									<TimeSelect :disabled="ifAddPrice" v-model="formInlineP.Period4EndTime" style="width: 70px;" />
								</FormItem>
								<FormItem prop="Period4Price" label="电费单价" :label-width="70">
									<Input :disabled="ifAddPrice" type="text" v-model="formInlineP.Period4Price" placeholder="电费单价"
										style="width: 55px;" />
								</FormItem>
								<FormItem prop="Period4ServicePrice" label="服务费" :label-width="70">
									<Input :disabled="ifAddPrice" type="text" v-model="formInlineP.Period4ServicePrice" placeholder="服务费"
										style="width: 55px;" />
								</FormItem>
							</Row>
							<Row style="margin-top: 10px;">
								<FormItem>
									<Tag color="primary">时段5</Tag>
								</FormItem>
								<FormItem prop="Period5BeginTime" label="时间" :label-width="40">
									<TimeSelect :disabled="ifAddPrice" v-model="formInlineP.Period5BeginTime" style="width: 70px;" />-
									<TimeSelect :disabled="ifAddPrice" v-model="formInlineP.Period5EndTime" style="width: 70px;" />
								</FormItem>
								<FormItem prop="Period5Price" label="电费单价" :label-width="70">
									<Input :disabled="ifAddPrice" type="text" v-model="formInlineP.Period5Price" placeholder="电费单价"
										style="width: 55px;" />
								</FormItem>
								<FormItem prop="Period5ServicePrice" label="服务费" :label-width="70">
									<Input :disabled="ifAddPrice" type="text" v-model="formInlineP.Period5ServicePrice" placeholder="服务费"
										style="width: 55px;" />
								</FormItem>
							</Row>
							<Row style="margin-top: 10px;">
								<FormItem>
									<Tag color="primary">时段6</Tag>
								</FormItem>
								<FormItem prop="Period6BeginTime" label="时间" :label-width="40">
									<TimeSelect :disabled="ifAddPrice" v-model="formInlineP.Period6BeginTime" style="width: 70px;" />-
									<TimeSelect :disabled="ifAddPrice" v-model="formInlineP.Period6EndTime" style="width: 70px;" />
								</FormItem>
								<FormItem prop="Period6Price" label="电费单价" :label-width="70">
									<Input :disabled="ifAddPrice" type="text" v-model="formInlineP.Period6Price" placeholder="电费单价"
										style="width: 55px;" />
								</FormItem>
								<FormItem prop="Period6ServicePrice" label="服务费" :label-width="70">
									<Input :disabled="ifAddPrice" type="text" v-model="formInlineP.Period6ServicePrice" placeholder="服务费"
										style="width: 55px;" />
								</FormItem>
							</Row>
							<Row style="margin-top: 10px;">
								<FormItem>
									<Tag color="primary">时段7</Tag>
								</FormItem>
								<FormItem prop="Period7BeginTime" label="时间" :label-width="40">
									<TimeSelect :disabled="ifAddPrice" v-model="formInlineP.Period7BeginTime" style="width: 70px;" />-
									<TimeSelect :disabled="ifAddPrice" v-model="formInlineP.Period7EndTime" style="width: 70px;" />
								</FormItem>
								<FormItem prop="Period7Price" label="电费单价" :label-width="70">
									<Input :disabled="ifAddPrice" type="text" v-model="formInlineP.Period7Price" placeholder="电费单价"
										style="width: 55px;" />
								</FormItem>
								<FormItem prop="Period7ServicePrice" label="服务费" :label-width="70">
									<Input :disabled="ifAddPrice" type="text" v-model="formInlineP.Period7ServicePrice" placeholder="服务费"
										style="width: 55px;" />
								</FormItem>
							</Row>
							<Row style="margin-top: 10px;">
								<FormItem>
									<Tag color="primary">时段8</Tag>
								</FormItem>
								<FormItem prop="Period8BeginTime" label="时间" :label-width="40">
									<TimeSelect :disabled="ifAddPrice" v-model="formInlineP.Period8BeginTime" style="width: 70px;" />-
									<TimeSelect :disabled="ifAddPrice" v-model="formInlineP.Period8EndTime" style="width: 70px;" />
								</FormItem>
								<FormItem prop="Period8Price" label="电费单价" :label-width="70">
									<Input :disabled="ifAddPrice" type="text" v-model="formInlineP.Period8Price" placeholder="电费单价"
										style="width: 55px;" />
								</FormItem>
								<FormItem prop="Period8ServicePrice" label="服务费" :label-width="70">
									<Input :disabled="ifAddPrice" type="text" v-model="formInlineP.Period8ServicePrice" placeholder="服务费"
										style="width: 55px;" />
								</FormItem>
							</Row>
							<Row style="margin-top: 10px;">
								<FormItem>
									<Tag color="primary">时段9</Tag>
								</FormItem>
								<FormItem prop="Period9BeginTime" label="时间" :label-width="40">
									<TimeSelect :disabled="ifAddPrice" v-model="formInlineP.Period9BeginTime" style="width: 70px;" />-
									<TimeSelect :disabled="ifAddPrice" v-model="formInlineP.Period9EndTime" style="width: 70px;" />
								</FormItem>
								<FormItem prop="Period9Price" label="电费单价" :label-width="70">
									<Input :disabled="ifAddPrice" type="text" v-model="formInlineP.Period9Price" placeholder="电费单价"
										style="width: 55px;" />
								</FormItem>
								<FormItem prop="Period9ServicePrice" label="服务费" :label-width="70">
									<Input :disabled="ifAddPrice" type="text" v-model="formInlineP.Period9ServicePrice" placeholder="服务费"
										style="width: 55px;" />
								</FormItem>
							</Row>
							<Row style="margin-top: 10px;">
								<FormItem>
									<Tag color="primary">时段10</Tag>
								</FormItem>
								<FormItem prop="Period10BeginTime" label="时间" :label-width="40">
									<TimeSelect :disabled="ifAddPrice" v-model="formInlineP.Period10BeginTime" style="width: 70px;" />-
									<TimeSelect :disabled="ifAddPrice" v-model="formInlineP.Period10EndTime" style="width: 70px;" />
								</FormItem>
								<FormItem prop="Period10Price" label="电费单价" :label-width="70">
									<Input :disabled="ifAddPrice" type="text" v-model="formInlineP.Period10Price" placeholder="电费单价"
										style="width: 55px;" />
								</FormItem>
								<FormItem prop="Period10ServicePrice" label="服务费" :label-width="70">
									<Input :disabled="ifAddPrice" type="text" v-model="formInlineP.Period10ServicePrice" placeholder="服务费"
										style="width: 55px;" />
								</FormItem>
							</Row>
							<Row style="margin-top: 10px;">
								<FormItem>
									<Tag color="primary">时段11</Tag>
								</FormItem>
								<FormItem prop="Period11BeginTime" label="时间" :label-width="40">
									<TimeSelect :disabled="ifAddPrice" v-model="formInlineP.Period11BeginTime" style="width: 70px;" />-
									<TimeSelect :disabled="ifAddPrice" v-model="formInlineP.Period11EndTime" style="width: 70px;" />
								</FormItem>
								<FormItem prop="Period11Price" label="电费单价" :label-width="70">
									<Input :disabled="ifAddPrice" type="text" v-model="formInlineP.Period11Price" placeholder="电费单价"
										style="width: 55px;" />
								</FormItem>
								<FormItem prop="Period11ServicePrice" label="服务费" :label-width="70">
									<Input :disabled="ifAddPrice" type="text" v-model="formInlineP.Period11ServicePrice" placeholder="服务费"
										style="width: 55px;" />
								</FormItem>
							</Row>
							<Row style="margin-top: 10px;">
								<FormItem>
									<Tag color="primary">时段12</Tag>
								</FormItem>
								<FormItem prop="Period12BeginTime" label="时间" :label-width="40">
									<TimeSelect :disabled="ifAddPrice" v-model="formInlineP.Period12BeginTime" style="width: 70px;" />-
									<TimeSelect :disabled="ifAddPrice" v-model="formInlineP.Period12EndTime" style="width: 70px;" />
								</FormItem>
								<FormItem prop="Period12Price" label="电费单价" :label-width="70">
									<Input :disabled="ifAddPrice" type="text" v-model="formInlineP.Period12Price" placeholder="电费单价"
										style="width: 55px;" />
								</FormItem>
								<FormItem prop="Period12ServicePrice" label="服务费" :label-width="70">
									<Input :disabled="ifAddPrice" type="text" v-model="formInlineP.Period12ServicePrice" placeholder="服务费"
										style="width: 55px;" />
								</FormItem>
							</Row>
<!-- 					<Row style="margin-top: 10px;">
								<Col span=3>
								<Tag color="primary">时段1</Tag>
								</Col>
								<Col span=5>
								<FormItem prop="Period1BeginTime" label="开始时间" :label-width="65">
									<TimeSelect :disabled="ifAddPrice" v-model="formInlineP.Period1BeginTime">
									</TimeSelect>
								</FormItem>
								</Col>
								<Col span=5>
								<FormItem prop="Period1EndTime" label="结束时间" :label-width="65">
									<TimeSelect :disabled="ifAddPrice" v-model="formInlineP.Period1EndTime">
									</TimeSelect>
								</FormItem>
								</Col>
								<Col span=5>
								<FormItem prop="Period1Price" label="电费单价" :label-width="65">
									<Input :disabled="ifAddPrice" type="text" v-model="formInlineP.Period1Price" placeholder="电费单价" />
								</FormItem>
								</Col>
								<Col span=5>
								<FormItem prop="Period1ServicePrice" label="服务费" :label-width="65">
									<Input :disabled="ifAddPrice" type="text" v-model="formInlineP.Period1ServicePrice"
										placeholder="服务费" />
								</FormItem>
								</Col>
							</Row>
							<Row style="margin-top: 10px;">
								<Col span=3>
								<Tag color="primary">时段2</Tag>
								</Col>
								<Col span=5>
								<FormItem prop="Period2BeginTime" label="开始时间" :label-width="65">
									<TimeSelect :disabled="ifAddPrice" v-model="formInlineP.Period2BeginTime">
									</TimeSelect>
								</FormItem>
								</Col>
								<Col span=5>
								<FormItem prop="Period2EndTime" label="结束时间" :label-width="65">
									<TimeSelect :disabled="ifAddPrice" v-model="formInlineP.Period2EndTime">
									</TimeSelect>
								</FormItem>
								</Col>
								<Col span=5>
								<FormItem prop="Period2Price" label="电费单价" :label-width="65">
									<Input :disabled="ifAddPrice" type="text" v-model="formInlineP.Period2Price" placeholder="电费单价" />
								</FormItem>
								</Col>
								<Col span=5>
								<FormItem prop="Period2ServicePrice" label="服务费" :label-width="65">
									<Input :disabled="ifAddPrice" type="text" v-model="formInlineP.Period2ServicePrice"
										placeholder="服务费" />
								</FormItem>
								</Col>
							</Row>
							<Row style="margin-top: 10px;">
								<Col span=3>
								<Tag color="primary">时段3</Tag>
								</Col>
								<Col span=5>
								<FormItem prop="Period3BeginTime" label="开始时间" :label-width="65">
									<TimeSelect :disabled="ifAddPrice" v-model="formInlineP.Period3BeginTime">
									</TimeSelect>
								</FormItem>
								</Col>
								<Col span=5>
								<FormItem prop="Period3EndTime" label="结束时间" :label-width="65">
									<TimeSelect :disabled="ifAddPrice" v-model="formInlineP.Period3EndTime">
									</TimeSelect>
								</FormItem>
								</Col>
								<Col span=5>
								<FormItem prop="Period3Price" label="电费单价" :label-width="65">
									<Input :disabled="ifAddPrice" type="text" v-model="formInlineP.Period3Price" placeholder="电费单价" />
								</FormItem>
								</Col>
								<Col span=5>
								<FormItem prop="Period3ServicePrice" label="服务费" :label-width="65">
									<Input :disabled="ifAddPrice" type="text" v-model="formInlineP.Period3ServicePrice"
										placeholder="服务费" />
								</FormItem>
								</Col>
							</Row>
							<Row style="margin-top: 10px;">
								<Col span=3>
								<Tag color="primary">时段4</Tag>
								</Col>
								<Col span=5>
								<FormItem prop="Period4BeginTime" label="开始时间" :label-width="65">
									<TimeSelect :disabled="ifAddPrice" v-model="formInlineP.Period4BeginTime">
									</TimeSelect>
								</FormItem>
								</Col>
								<Col span=5>
								<FormItem prop="Period4EndTime" label="结束时间" :label-width="65">
									<TimeSelect :disabled="ifAddPrice" v-model="formInlineP.Period4EndTime">
									</TimeSelect>
								</FormItem>
								</Col>
								<Col span=5>
								<FormItem prop="Period4Price" label="电费单价" :label-width="65">
									<Input :disabled="ifAddPrice" type="text" v-model="formInlineP.Period4Price" placeholder="电费单价" />
								</FormItem>
								</Col>
								<Col span=5>
								<FormItem prop="Period4ServicePrice" label="服务费" :label-width="65">
									<Input :disabled="ifAddPrice" type="text" v-model="formInlineP.Period4ServicePrice"
										placeholder="服务费" />
								</FormItem>
								</Col>
							</Row>
							<Row style="margin-top: 10px;">
								<Col span=3>
								<Tag color="primary">时段5</Tag>
								</Col>
								<Col span=5>
								<FormItem prop="Period5BeginTime" label="开始时间" :label-width="65">
									<TimeSelect :disabled="ifAddPrice" v-model="formInlineP.Period5BeginTime">
									</TimeSelect>
								</FormItem>
								</Col>
								<Col span=5>
								<FormItem prop="Period5EndTime" label="结束时间" :label-width="65">
									<TimeSelect :disabled="ifAddPrice" v-model="formInlineP.Period5EndTime">
									</TimeSelect>
								</FormItem>
								</Col>
								<Col span=5>
								<FormItem prop="Period5Price" label="电费单价" :label-width="65">
									<Input :disabled="ifAddPrice" type="text" v-model="formInlineP.Period5Price" placeholder="电费单价" />
								</FormItem>
								</Col>
								<Col span=5>
								<FormItem prop="Period5ServicePrice" label="服务费" :label-width="65">
									<Input :disabled="ifAddPrice" type="text" v-model="formInlineP.Period5ServicePrice"
										placeholder="服务费" />
								</FormItem>
								</Col>
							</Row>
							<Row style="margin-top: 10px;">
								<Col span=3>
								<Tag color="primary">时段6</Tag>
								</Col>
								<Col span=5>
								<FormItem prop="Period6BeginTime" label="开始时间" :label-width="65">
									<TimeSelect :disabled="ifAddPrice" v-model="formInlineP.Period6BeginTime">
									</TimeSelect>
								</FormItem>
								</Col>
								<Col span=5>
								<FormItem prop="Period6EndTime" label="结束时间" :label-width="65">
									<TimeSelect :disabled="ifAddPrice" v-model="formInlineP.Period6EndTime">
									</TimeSelect>
								</FormItem>
								</Col>
								<Col span=5>
								<FormItem prop="Period6Price" label="电费单价" :label-width="65">
									<Input :disabled="ifAddPrice" type="text" v-model="formInlineP.Period6Price" placeholder="电费单价" />
								</FormItem>
								</Col>
								<Col span=5>
								<FormItem prop="Period6ServicePrice" label="服务费" :label-width="65">
									<Input :disabled="ifAddPrice" type="text" v-model="formInlineP.Period6ServicePrice"
										placeholder="服务费" />
								</FormItem>
								</Col>
							</Row>
							<Row style="margin-top: 10px;">
								<Col span=3>
								<Tag color="primary">时段7</Tag>
								</Col>
								<Col span=5>
								<FormItem prop="Period7BeginTime" label="开始时间" :label-width="65">
									<TimeSelect :disabled="ifAddPrice" v-model="formInlineP.Period7BeginTime">
									</TimeSelect>
								</FormItem>
								</Col>
								<Col span=5>
								<FormItem prop="Period7EndTime" label="结束时间" :label-width="65">
									<TimeSelect :disabled="ifAddPrice" v-model="formInlineP.Period7EndTime">
									</TimeSelect>
								</FormItem>
								</Col>
								<Col span=5>
								<FormItem prop="Period7Price" label="电费单价" :label-width="65">
									<Input :disabled="ifAddPrice" type="text" v-model="formInlineP.Period7Price" placeholder="电费单价" />
								</FormItem>
								</Col>
								<Col span=5>
								<FormItem prop="Period7ServicePrice" label="服务费" :label-width="65">
									<Input :disabled="ifAddPrice" type="text" v-model="formInlineP.Period7ServicePrice"
										placeholder="服务费" />
								</FormItem>
								</Col>
							</Row>
							<Row style="margin-top: 10px;">
								<Col span=3>
								<Tag color="primary">时段8</Tag>
								</Col>
								<Col span=5>
								<FormItem prop="Period8BeginTime" label="开始时间" :label-width="65">
									<TimeSelect :disabled="ifAddPrice" v-model="formInlineP.Period8BeginTime">
									</TimeSelect>
								</FormItem>
								</Col>
								<Col span=5>
								<FormItem prop="Period8EndTime" label="结束时间" :label-width="65">
									<TimeSelect :disabled="ifAddPrice" v-model="formInlineP.Period8EndTime">
									</TimeSelect>
								</FormItem>
								</Col>
								<Col span=5>
								<FormItem prop="Period8Price" label="电费单价" :label-width="65">
									<Input :disabled="ifAddPrice" type="text" v-model="formInlineP.Period8Price" placeholder="电费单价" />
								</FormItem>
								</Col>
								<Col span=5>
								<FormItem prop="Period8ServicePrice" label="服务费" :label-width="65">
									<Input :disabled="ifAddPrice" type="text" v-model="formInlineP.Period8ServicePrice"
										placeholder="服务费" />
								</FormItem>
								</Col>
							</Row>
							<Row style="margin-top: 10px;">
								<Col span=3>
								<Tag color="primary">时段9</Tag>
								</Col>
								<Col span=5>
								<FormItem prop="Period9BeginTime" label="开始时间" :label-width="65">
									<TimeSelect :disabled="ifAddPrice" v-model="formInlineP.Period9BeginTime">
									</TimeSelect>
								</FormItem>
								</Col>
								<Col span=5>
								<FormItem prop="Period9EndTime" label="结束时间" :label-width="65">
									<TimeSelect :disabled="ifAddPrice" v-model="formInlineP.Period9EndTime">
									</TimeSelect>
								</FormItem>
								</Col>
								<Col span=5>
								<FormItem prop="Period9Price" label="电费单价" :label-width="65">
									<Input :disabled="ifAddPrice" type="text" v-model="formInlineP.Period9Price" placeholder="电费单价" />
								</FormItem>
								</Col>
								<Col span=5>
								<FormItem prop="Period9ServicePrice" label="服务费" :label-width="65">
									<Input :disabled="ifAddPrice" type="text" v-model="formInlineP.Period9ServicePrice"
										placeholder="服务费" />
								</FormItem>
								</Col>
							</Row>
							<Row style="margin-top: 10px;">
								<Col span=3>
								<Tag color="primary">时段10</Tag>
								</Col>
								<Col span=5>
								<FormItem prop="Period10BeginTime" label="开始时间" :label-width="65">
									<TimeSelect :disabled="ifAddPrice" v-model="formInlineP.Period10BeginTime">
									</TimeSelect>
								</FormItem>
								</Col>
								<Col span=5>
								<FormItem prop="Period10EndTime" label="结束时间" :label-width="65">
									<TimeSelect :disabled="ifAddPrice" v-model="formInlineP.Period10EndTime">
									</TimeSelect>
								</FormItem>
								</Col>
								<Col span=5>
								<FormItem prop="Period10Price" label="电费单价" :label-width="65">
									<Input :disabled="ifAddPrice" type="text" v-model="formInlineP.Period10Price" placeholder="电费单价" />
								</FormItem>
								</Col>
								<Col span=5>
								<FormItem prop="Period10ServicePrice" label="服务费" :label-width="65">
									<Input :disabled="ifAddPrice" type="text" v-model="formInlineP.Period10ServicePrice"
										placeholder="服务费" />
								</FormItem>
								</Col>
							</Row>
							<Row style="margin-top: 10px;">
								<Col span=3>
								<Tag color="primary">时段11</Tag>
								</Col>
								<Col span=5>
								<FormItem prop="Period11BeginTime" label="开始时间" :label-width="65">
									<TimeSelect :disabled="ifAddPrice" v-model="formInlineP.Period11BeginTime">
									</TimeSelect>
								</FormItem>
								</Col>
								<Col span=5>
								<FormItem prop="Period11EndTime" label="结束时间" :label-width="65">
									<TimeSelect :disabled="ifAddPrice" v-model="formInlineP.Period11EndTime">
									</TimeSelect>
								</FormItem>
								</Col>
								<Col span=5>
								<FormItem prop="Period11Price" label="电费单价" :label-width="65">
									<Input :disabled="ifAddPrice" type="text" v-model="formInlineP.Period11Price" placeholder="电费单价" />
								</FormItem>
								</Col>
								<Col span=5>
								<FormItem prop="Period11ServicePrice" label="服务费" :label-width="65">
									<Input :disabled="ifAddPrice" type="text" v-model="formInlineP.Period11ServicePrice"
										placeholder="服务费" />
								</FormItem>
								</Col>
							</Row>
							<Row style="margin-top: 10px;">
								<Col span=3>
								<Tag color="primary">时段12</Tag>
								</Col>
								<Col span=5>
								<FormItem prop="Period12BeginTime" label="开始时间" :label-width="65">
									<TimeSelect :disabled="ifAddPrice" v-model="formInlineP.Period12BeginTime">
									</TimeSelect>
								</FormItem>
								</Col>
								<Col span=5>
								<FormItem prop="Period12EndTime" label="结束时间" :label-width="65">
									<TimeSelect :disabled="ifAddPrice" v-model="formInlineP.Period12EndTime">
									</TimeSelect>
								</FormItem>
								</Col>
								<Col span=5>
								<FormItem prop="Period12Price" label="电费单价" :label-width="65">
									<Input :disabled="ifAddPrice" type="text" v-model="formInlineP.Period12Price" placeholder="电费单价" />
								</FormItem>
								</Col>
								<Col span=5>
								<FormItem prop="Period12ServicePrice" label="服务费" :label-width="65">
									<Input :disabled="ifAddPrice" type="text" v-model="formInlineP.Period12ServicePrice"
										placeholder="服务费" />
								</FormItem>
								</Col>
							</Row> -->
						</Form>
					</div>
				</div>
				<div slot="right" class="demo-split-pane">
					<Form ref="formInline" :model="formInline" inline style="text-align: left;margin-top: 1%;">
						<FormItem prop="trackName" label="充电站:" :label-width="80">
							<Select filterable placeholder="站点列表" style="width: 120px;" v-model="formInline.StationId">
								<Option :value=0>全部</Option>
								<Option v-bind:key="item.StationId" v-for="(item) in StationList" :value="item.StationId">{{item.StationName}}</Option>
							</Select>
						</FormItem>
						<!-- <FormItem label="设备型号" prop="EquipmentModel" :label-width="70">
							<Select filterable placeholder="选择预设模板" v-model="formInline.EquipmentModel">
								<Option v-bind:key="item.ModelId" v-for="(item,itemIndex) in EquipmentModelDefine" :value="item.ModelId">{{item.ModelDesc}}</Option>
							</Select>
						</FormItem> -->
						<FormItem prop="EquipmentNo" label="设备编号:" :label-width="100">
							<Input type="text" v-model="formInline.EquipmentNo" placeholder="设备编号"  style="width: 120px;"/>
						</FormItem>
						<FormItem label="设备类型" prop="EquipmentType" :label-width="70">
							<!-- <Input v-model="FormItem.EquipmentType" placeholder="输入设备类型"></Input> -->
							<Select placeholder="输入设备类型" v-model="formInline.EquipmentType" style="width: 120px;">
								<Option :value='0'>全部设备</Option>
								<Option :value='1'>直流设备</Option>
								<Option :value='2'>交流设备</Option>
								<Option :value='3'>交直流一体设备</Option>
								<Option :value='4'>无线设备</Option>
								<Option :value='5'>其他</Option>
							</Select>
						</FormItem>
						<FormItem>
							<Button type="primary" @click="handleSubmit('formInline')" v-if="hasWidgets('search')">查询</Button>
						</FormItem>
						<FormItem style="float: right;" v-if="priceModal=='查询'">
							<Button type="primary" @click="show('command')" v-if="hasWidgets('setPrice')">下发价格</Button>
						</FormItem>
					</Form>
					<Table style="width: 100%;" @on-selection-change="selectChange" :columns="columns1" :data="data1"
						:height="tableHeight" size="small"></Table>
					<MyPage ref="sonPage" :param="pageParam" :url="getEquipmentListForPriceManageUrl" @listData='getDeviceData'>
					</MyPage>
				</div>
			</Split>
		</div>
	</div>
</template>

<script>
	import dateFormat from '../../../../public/js/comm.js'
	import Qs from 'qs'
	//import expandRow from './StationManagementExpand.vue';
	import {
		mapState,
		mapGetters,
		mapActions
	} from 'vuex'
	import webapi from '../../../webapi.js'
	export default {
		data() {
			return {
				getEquipmentListForPriceManageUrl: webapi.base_api_url + '/Archives/GetEquipmentListForPriceManage',
				//ifQueryPrice: false,
				//右侧实时价格的枪编号
				currentConn: '',
				priceModal: '新增',
				value: '',
				//面板分割比例
				split1: 0.45,
				loadingStatus: false,
				//model表单
				params: "", //table 传参
				tableHeight: "650",
				modal: {
					Title: "场站添加",
					type: "addStation"
				},
				modalView: false,
				//价格模板禁用
				ifAddPrice: false,
				selectPriceId: '',
				formInlineP: {
					Id: 0,
					Name: '',
					Period1BeginTime: "00:00",
					Period1EndTime: "00:00",
					Period1Price: "0",
					Period1ServicePrice: "0",

					Period2BeginTime: "00:00",
					Period2EndTime: "00:00",
					Period2Price: "0",
					Period2ServicePrice: "0",

					Period3BeginTime: "00:00",
					Period3EndTime: "00:00",
					Period3Price: "0",
					Period3ServicePrice: "0",

					Period4BeginTime: "00:00",
					Period4EndTime: "00:00",
					Period4Price: "0",
					Period4ServicePrice: "0",

					Period5BeginTime: "00:00",
					Period5EndTime: "00:00",
					Period5Price: "0",
					Period5ServicePrice: "0",

					Period6BeginTime: "00:00",
					Period6EndTime: "00:00",
					Period6Price: "0",
					Period6ServicePrice: "0",

					Period7BeginTime: "00:00",
					Period7EndTime: "00:00",
					Period7Price: "0",
					Period7ServicePrice: "0",

					Period8BeginTime: "00:00",
					Period8EndTime: "00:00",
					Period8Price: "0",
					Period8ServicePrice: "0",

					Period9BeginTime: "00:00",
					Period9EndTime: "00:00",
					Period9Price: "0",
					Period9ServicePrice: "0",

					Period10BeginTime: "00:00",
					Period10EndTime: "00:00",
					Period10Price: "0",
					Period10ServicePrice: "0",

					Period11BeginTime: "00:00",
					Period11EndTime: "00:00",
					Period11Price: "0",
					Period11ServicePrice: "0",

					Period12BeginTime: "00:00",
					Period12EndTime: "00:00",
					Period12Price: "0",
					Period12ServicePrice: "0",

					//废弃字段
					//ServicePrice: 0,
					ModifyTime: dateFormat.formatDate(new Date(), 'yyyy-MM-dd'),
					ModifyBy: 0,
					//PriceType: 1,
					//Previous: -2
				},
				BreadcrumbList: ['档案管理', '>>', '价格管理'],
				formInline: {
					StationId: 0,
					//EquipmentModel: '',
					EquipmentType: 0,
					EquipmentNo: ''
				},
				//table标题数据
				columns1: [{
						type: 'selection',
						width: 60,
						align: 'center'
					}, {
						title: '充电枪编号',
						key: 'ConnectorNo',
						width: 100
					},
					// {
					// 	title: '设备型号',
					// 	key: 'EquipmentModel',
					// 	width: 150
					// },
					{
						title: '设备类型',
						key: 'EquipmentType',
						width: 100,
						render: (h, params) => {
							return h('div', params.row.EquipmentTypeDesc)
						}
					},
					{
						title: '所属场站',
						key: 'StationName',
						width: 150
					},
					{
						title: '模板名称',
						key: 'PriceTemplateName',
						width: 150
					},
					{
						title: '操作员',
						key: 'Operator',
						width: 150
					},
					{
						title: '是否成功',
						key: 'Msg',
						width: 100,
						render: (h, params) => {
							let fcolor = '#ff0000';
							if (params.row.Msg == '下发成功') {
								fcolor = '#55ff7f'
							}
							return h('div', {
								style: {
									color: fcolor,
								},
							}, params.row.Msg)
						}
					}, {
						title: '操作',
						key: 'action',
						align: 'center',
						render: (h, params) => {
							let arr = [];
							arr.push(h('div', [
								this.hasWidgets('queryPrice') ? h('Button', {
									props: {
										type: 'primary',
										size: 'small'
									},
									style: {
										marginRight: '5px'
									},
									on: {
										click: () => {
											this.show("selectPrice", params.row.ConnectorNo)
										}
									}
								}, '查询价格') : h()
							]))
							// if(this.ifAddPrice){
							// arr.push(
							//  h('div', [
							// 	h('Button', {
							// 		props: {
							// 			type: 'primary',
							// 			size: 'small'
							// 		},
							// 		style: {
							// 			marginRight: '5px'
							// 		},
							// 		on: {
							// 			click: () => {
							// 				this.$Modal.confirm({
							// 					title: '选中价格模板---->'+this.formInlineP.Name,
							// 					okText: '取消',
							// 					cancelText: '确定',
							// 					onCancel: () => {
							// 						this.show("command", params.row.ConnectorNo)
							// 					}
							// 				});
							// 			}
							// 		}
							// 	}, '下发')
							// ])
							// )
							// }
							return h('div', arr)
						}
					}
				],
				data1: [],
				tableSelectItems: []
			};
		},
		created() {
			const _this = this;
			_this.tableHeight = window.innerHeight - 220;
			window.addEventListener('resize', this.getTableHeight)
		},
		destroyed() {
			window.removeEventListener("resize", this.getTableHeight);
		},
		mounted() {
			this.handleSubmit();
		},
		computed: {
			pageParam: function() {
				const _this = this;
				const param = {
					StationId: _this.formInline.StationId,
					EquipmentType: _this.formInline.EquipmentType,
					//EquipmentType: _this.formInline.EquipmentType,
					EquipmentNo: _this.formInline.EquipmentNo,
					Type: 1,
				}
				return param
			},
			//直接选属性
			...mapState({
				StationList: 'Stations',
				PriceList: 'riceModelDefine',
				EquipmentModelDefine: 'EquipmentModelDefine'
			})
		},
		methods: {
			...mapActions([
				'GetPriceModelDefine',
			]),
			selectChange: function(a) {
				this.tableSelectItems = a.map(function(station) {
					console.log(station.ConnectorNo);
					return station.ConnectorNo;
				})
			},
			hasWidgets: function(widgetName) {
				return this.$route.meta.widgets.find(w => w.Name == widgetName);
			},
			//操作
			show: function(type, params) {
				switch (type) {
					case "command":
						this.$Modal.confirm({
							title: '选中价格模板---->' + this.formInlineP.Name,
							okText: '取消',
							cancelText: '确定',
							onCancel: () => {
								this.commandBatch()
							}
						});
						break;
					case "commands_batch":
						alert("批量下发命令：" + this.tableSelectItems)
						break;
					case "selectPrice":
						//this.selectPriceId=params
						this.priceModal = '实时价格'
						this.currentConn = params
						this.$refs.formInlineP.resetFields()
						this.QueryPrice(params)
						break;
				}
			},
			//查询枪实时价格
			QueryPrice: function(ConnectorNo) {
				const _this = this
				let parms = {
					ConnectorNo: ConnectorNo,
					Type: 1
				};
				_this.$axios.post(webapi.base_api_url + "/Archives/QueryPrice", parms, {}).then(res => {
					console.log("res")
					if (res.data.Code == 0) {
						_this.$Message.success("查询成功,左侧查看价格信息");
						_this.formInlineP = res.data.Data
					} else {
						_this.$Message.success(res.data.Msg + "---" + res.data.Data);
					}
				}).catch(error => {
					_this.$Message.success(error.data.Msg + "---" + error.data.Data);
				})
			},
			commandBatch: function() {
				const _this = this
				if (_this.tableSelectItems.length > 0 && _this.selectPriceId != '' && _this.priceModal == '查询') {
					let parms = {
						TemplateId: _this.selectPriceId,
						List: _this.tableSelectItems
					};
					_this.$axios.post(webapi.base_api_url + "/Archives/SetPriceConnector", parms, {}).then(res => {
						console.log("res")
						if (res.data.Code == 0) {
							// {
							// 	"Msg": "请求成功",
							// 	"Code": 0,
							// 	"Data": [{
							// 		"ConnectorNo": "500045A",
							// 		"Code": 0,
							// 		"Msg": "Successs"
							// 	}, {
							// 		"ConnectorNo": "500045B",
							// 		"Code": 1006,
							// 		"Msg": "发送数据给电桩失败"
							// 	}]
							// }
							res.data.Data.forEach(function(item, index) {
								_this.data1.forEach(function(item2, index2) {
									if (item.ConnectorNo == item2.ConnectorNo) {
										if (item.Code == 0) {
											item2.Msg = "下发成功"
											item2.PriceTemplateName = _this.formInlineP.Name
										} else {
											item2.Msg = "下发失败"
										}
										// item2.Msg = item.Msg
									}
								})
							})
							_this.tableSelectItems = []
						}
					})
				} else {
					_this.$Message.error("请选择查询价格模板以及选中要下发的枪选项")
				}
			},
			getDeviceData: function(data) {
				this.data1 = data.Data.List
			},
			handleSubmit: function() {
				this.$refs.sonPage.getList();
			},
			getTableHeight: function() {
				this.tableHeight = window.innerHeight - 220;
			},
			//控制新增还是查询
			handleSubmitP: function(type) {
				switch (type) {
					case 'add':
						this.addPriceTemplate()
						break;
					case 'changeModalAdd':
						this.$refs.formInlineP.resetFields()
						this.priceModal = "新增"
						break;
					case 'changeModalSelect':
						this.$refs.formInlineP.resetFields()
						this.priceModal = "查询"
						this.showPriceModel(this.selectPriceId)
						break;
					default:
						break;
				}
			},
			//添加价格模板
			addPriceTemplate: function() {
				const _this = this;
				_this.formInlineP.Id = 0
				let parms = _this.formInlineP;
				parms.type = 1;
				_this.$axios.post(webapi.base_api_url + "/Archives/AddPriceTemplate", parms, {}).then(res => {
					console.log("添加价格模板")
					if (res.data.Code == 0) {
						_this.$Message.info("添加价格模板成功");
						_this.GetPriceModelDefine()
					} else {
						_this.$Message.info("添加价格模板失败:" + res.data.Data);
					}
				})
			},
			showPriceModel: function(value) {
				let abj = this.PriceList.filter(function(priceModel) {
					return priceModel.Id == value
				})[0]
				this.formInlineP = Object.assign({}, abj)
			}
		},
	}
</script>

<style>
	/* 	#tree{
		width: 1200px;
		height: 600px;
		margin-top: 7%;
		border: 2px solid red;
	} */

	.ivu-tag-dot {
		border: 0px solid #e8eaec !important;
	}

	.ivu-form-item {
		margin-bottom: 10px;
	}

	.ivu-col-span-7 {
		margin-left: 2%;
	}

	.demo-split {
		height: 97%;
		border: 5px solid #e2e2dc;
	}

	.demo-split-pane {
		padding: 10px;

	}
</style>
